import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { FairContext } from './fair-context';

/**
 * Só entra nas telas da feira com a feira carregada.
 *
 * Endereço que não leva a feira nenhuma vai para "feira não encontrada", que
 * oferece a lista de feiras — um QR antigo ou um link digitado errado não
 * pode terminar em tela vazia.
 */
export const fairGuard: CanActivateFn = async (route) => {
	// Tudo o que é injetado vem antes do `await`: depois dele o contexto de
	// injeção acabou, e a feira inexistente quebraria em vez de redirecionar.
	const context = inject(FairContext);
	const router = inject(Router);
	const slug = route.paramMap.get('fairSlug') ?? '';
	const fair = await context.load(slug);
	return fair ? true : router.createUrlTree(['/feira-nao-encontrada'], { queryParams: { endereco: slug } });
};

/**
 * Páginas da plataforma — lista de feiras, entrar, organizadores, documentos
 * legais — saem da feira: a cor de ação volta a ser o violeta da NEXPO.
 */
export const platformGuard: CanActivateFn = () => {
	inject(FairContext).clear();
	return true;
};
